import { watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useAuthenticationStore } from '@cplug/frontend-shared-domains/domain/authentication'
import { defineNuxtPlugin } from '#app'
import useTwoFactorStore from '~/domain/shared/two-factor/stores/useTwoFactorStore'

export default defineNuxtPlugin(() => {
  const authStore = useAuthenticationStore()
  const { logged } = storeToRefs(authStore)
  const twoFactorStore = useTwoFactorStore()

  watch(logged, (isLogged, wasLogged) => {
    if (wasLogged === true && isLogged === false) {
      twoFactorStore.clearBackupCodesCache()
    }
  })
})
